import React from 'react';

export const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <h1 className="text-xl font-semibold text-gray-900">Privacy Policy</h1>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="prose prose-blue max-w-none">
          <p className="text-sm text-gray-500">Last updated: October 19, 2025</p>

          <h2>Introduction</h2>
          <p>
            This Privacy Policy explains how How I Met Your Mortgage ("we", "us", or "our") collects,
            uses, and shares your information when you use our website and services (the "Services"). By
            using the Services, you agree to the collection and use of information in accordance with this
            policy.
          </p>

          <h2>Information We Collect</h2>
          <p>
            We collect information you provide directly to us, such as your name, email address, and
            saved analyses. We also collect usage data and device information automatically through cookies
            and similar technologies to improve our Services.
          </p>

          <h3>Account and Authentication</h3>
          <p>
            If you create an account or sign in using third-party providers, we receive basic profile
            information necessary to authenticate you and provide access to premium features.
          </p>

          <h3>Payment Information</h3>
          <p>
            Subscription and payment processing are handled by our payment processor. We do not store your
            full payment card details on our servers. We receive limited information about your subscription
            status to enable premium features.
          </p>

          <h2>How We Use Your Information</h2>
          <ul>
            <li>Provide, maintain, and improve the Services</li>
            <li>Process subscriptions and manage premium access</li>
            <li>Communicate with you about updates and support</li>
            <li>Protect against, investigate, and deter fraudulent or illegal activity</li>
          </ul>

          <h2>Data Sharing and Transfers</h2>
          <p>
            We may share information with service providers who perform services on our behalf (e.g.,
            authentication, analytics, payment processing). These parties are bound to protect your
            information and may only use it as directed by us.
          </p>

          <h2>Cookies</h2>
          <p>
            We use cookies and similar technologies to remember your preferences and analyze usage. You can
            control cookies through your browser settings, but some features of the Services may not function
            properly without them.
          </p>

          <h2>Data Retention</h2>
          <p>
            We retain your information for as long as necessary to provide the Services and for other
            legitimate business purposes, including complying with legal obligations and resolving disputes.
          </p>

          <h2>Your Rights</h2>
          <p>
            Depending on your location, you may have rights to access, correct, or delete your personal
            information, and to object to or restrict certain processing. To exercise these rights, contact
            us at <a href="mailto:support@howimetyourmortgage.com">support@howimetyourmortgage.com</a>.
          </p>

          <h2>Children's Privacy</h2>
          <p>
            Our Services are not directed to children under 13, and we do not knowingly collect personal
            information from children under 13.
          </p>

          <h2>Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of material changes by
            updating the date at the top of this page and, where appropriate, providing additional notice.
          </p>

          <h2>Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy, contact us at
            <a href="mailto:support@howimetyourmortgage.com"> support@howimetyourmortgage.com</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;


